import type { SyntheticEvent } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../../components/Layout/Layout';
import ChatDetails from '../../containers/ChatDetails/ChatDetails';
import { useAppSelector } from '../../hooks';
import { selectCurrentChat } from '../../containers/ChatsList/chatListSlice';
import { getHeaderBackgroundColor } from '../../containers/Chat/helpers';

function ChatDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const message = useAppSelector(selectCurrentChat);
  const [optionsOpen, setOptionsOpen] = useState(false);
  const [headerBackgroundColor, setHeaderBackgroundColor] = useState<undefined | string>(undefined);

  useEffect(() => {
    if (message) setHeaderBackgroundColor(getHeaderBackgroundColor(message));
  }, [message, message?.type, message?.emergencyTypeColor, message?.recalled]);

  const onClickOptions = () => {
    setOptionsOpen(!optionsOpen);
  };

  const handleNavigate = (e: SyntheticEvent) => {
    e.preventDefault();
    navigate(`/message/${id}`, { state: { fromDetails: true } });
  };

  return (
    <Layout
      isMessageLayout
      to="#"
      message="messages_details"
      backBtn
      backBtnCallBack={handleNavigate}
      headerBackgroundColor={headerBackgroundColor}
      dotsCallBack={onClickOptions}
      showBottomTabs
    >
      <ChatDetails
        optionsOpen={optionsOpen}
        setOptionsOpen={setOptionsOpen}
        onClickOptions={setOptionsOpen}
      />
    </Layout>
  );
}

export default ChatDetailsPage;
